var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.meta.color,"small":"","dark":""}},[_vm._v("\n  "+_vm._s(_vm.meta.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }